import {useContext} from 'react'
import {CarouselContext} from '../context'

const noop = (): void => {}

const useNotifyUpdatedCards = (): (() => void) => {
  const {notifyUpdatedCards} = useContext(CarouselContext)

  return notifyUpdatedCards ?? noop
}

export default useNotifyUpdatedCards
